<style lang="less" scoped>
.after {text-align: left;background-color: #fcfcfc;width: 286px;}
.after .el-form-item {width: 100%;}
.after .el-button {height: 40px;}
.after .preview {margin-left: 10px;}
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
table {border-collapse: collapse;width: 100%;}
.time {width: 440px;}
.sort {width: 150px;}
.sort /deep/.el-input {width: 150px;}
.date-picker.el-input {width: 200px;}
.date-picker.el-input {width: 200px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.classification {width: 150px;}
.classification /deep/ .el-input__inner {width: 150px;}
.pagination{margin-bottom: 40px;}
.btnBox {width: 160px;}
/deep/.video-js .vjs-big-play-button{top: 45%;left: 45%;}
/deep/.hide .el-upload--picture-card {display: none;}
</style>

<template>
  <div class="yszt">
    <el-form ref="form" :model="form">
      <table>
        <tr>
          <td class="after">
            <el-form-item>
              <el-upload
                class="upload-demo"
                :action="url"
                :limit="1"
                :on-success="onSuccess"
                :on-remove="handleRemoveVideo"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                :before-upload="beforeUploadVideo"
                @mouseover.native="getVidUrl"
                :on-exceed="exceed">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <el-button style="margin-left: 15px;" size="small" type="success" @click="preview()">点击预览</el-button>
                <el-button style="margin-left: 15px;" size="small" type="success" @click="present()">点击提交</el-button>
              </el-upload>
            </el-form-item>
            <el-dialog :visible.sync="dialogVisible" >
              <video-player ref="videoPlayer" :playsinline="true" :options="playerOptions" v-if="dialogVisible"></video-player>
            </el-dialog>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="el-tablebox">
      <el-table
        ref="multipleTable"
        :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        stripe
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center',}">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="type" label="视频分类"></el-table-column>
        <el-table-column prop="name" label="视频名称"></el-table-column>
        <el-table-column prop="video" label="视频查看">
          <template slot-scope="scope">
            <el-button style="margin-left: 15px;" size="small" type="success" @click="preview1(scope.row)">点击查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="addtime" label="上传时间">
          <template slot-scope="scope">{{(scope.row.addtime * 1000) | formatTime()}}</template>
        </el-table-column>
        <el-table-column prop="id" label="操作">
          <template slot-scope="scope">
            <el-button type="success" @click="cancelshowfn(scope.row)" v-if="scope.row.shows === 1 && show1">取消</el-button>
            <el-button type="success" @click="showfn(scope.row)" v-if="scope.row.shows === 0 && show2">置顶</el-button>
            <el-button type="danger" @click="delfn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="1">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 安进
 * 线上云展-展厅视频管理
 */
import playVideo from '../../../app/method/playVideo'
import filters from '../../method/filter'
export default {
  mixins: [playVideo, filters],
  data()
  {
    return {
      url: '',
      form: {
        video: ''
      },
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      pageSize: 20,
      currentPage: 1,
      tableData: [],
      show1: false,
      show2: false,
      hideUploadEdit: false
    }
  },
  mounted()
  {
    this.getList()
  },
  created()
  {
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    if (userInfo.userno === 'admin' || userInfo.role.indexOf(1) !== -1 || userInfo.role.indexOf(5) !== -1 || userInfo.role.indexOf(8) !== -1)
    {
      this.show1 = true
      this.show2 = true
    }
    else
    {
      this.show1 = false
      this.show2 = false
    }
  },
  methods: {
    preview()
    {
      this.playerOptions.sources[0].src = this.form.video
      if (this.playerOptions.sources[0].src)
        this.dialogVisible = true
      else
        this.$message({message: '您还没有上传视频，暂可内容预览', type: 'error', customClass: 'mzindex'})
    },
    preview1(row)
    {
      this.playerOptions.sources[0].src = row.video
      if (this.playerOptions.sources[0].src)
        this.dialogVisible = true
      else
        this.$message({message: '您还没有上传视频，暂可内容预览', type: 'error', customClass: 'mzindex'})
    },
    present()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 56,
        retAtt: 1,
        type: 1,
        name: '云上展厅视频',
        addtime: (Date.parse(new Date()) / 1000),
        video: this.form.video,
        thumb: 1,
        shows: 0
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 0)
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.getList()
        }
        else
          this.$message({message: '添加失败', type: 'error', customClass: 'mzindex'})
      })
    },
    getList()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 56,
        _exp: 'type=?',
        types: 's',
        vals: 1,
        orderby: 'addtime DESC'
      }
      window.post.getPost(paras).then((ret) =>
      {
        let temp = []
        ret.forEach((item) =>
        {
          temp.push({
            id: item.id,
            type: item.type,
            name: item.video.substring(item.video.lastIndexOf('/') + 1, item.video.length),
            addtime: +item.addtime,
            video: item.video,
            shows: item.shows
          })
          this.tableData = temp
        })
      })
    },
    delfn(row)
    {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>
      {
        let obj = {
          cmd: 'delete',
          _major: 11,
          _minor: 56,
          id: row.id
        }
        window.post.getPost(obj).then((ret) =>
        {
          this.$message({message: '删除成功', type: 'success', customClass: 'mzindex'})
          this.getList()
        })
      }).catch(() =>
      {
        this.$message({message: '已取消删除', type: 'info', customClass: 'mzindex'})
      })
    },
    cancelshowfn(row)
    {
      this.$confirm('此操作取消置顶, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>
      {
        let obj = {
          cmd: 'updateAtt',
          _major: 11,
          _minor: 56,
          retAtt: 1,
          id: row.id,
          shows: 0
        }
        window.post.getPost(obj).then((ret) =>
        {
          if (ret.ret === 0)
          {
            this.$message({message: '取消置顶成功', type: 'success', customClass: 'mzindex'})
            this.getList()
          }
          else
            this.$message({message: '取消置顶失败', type: 'error', customClass: 'mzindex'})
        })
      }).catch(() =>
      {
        this.$message({message: '已取消删除', type: 'info', customClass: 'mzindex'})
      })
    },
    showfn(row)
    {
      this.$confirm('此操作将置顶视频, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>
      {
        let obj = {
          cmd: 'query',
          _major: 11,
          _minor: 56,
          retAtt: 1,
          _exp: 'id>0 and type = 1'
        }
        window.post.getPost(obj).then((ret) =>
        {
          ret.forEach((item) =>
          {
            if (row.id === item.id)
            {
              let obj = {
                cmd: 'updateAtt',
                _major: 11,
                _minor: 56,
                retAtt: 1,
                id: row.id,
                shows: 1
              }
              window.post.getPost(obj).then((ret) =>
              {
                if (ret.ret === 0)
                {
                  this.$message({message: '置顶成功', type: 'success', customClass: 'mzindex'})
                  this.getList()
                }
                else
                  this.$message({message: '置顶失败', type: 'error', customClass: 'mzindex'})
              })
            }
            else
            {
              let obj = {
                cmd: 'updateAtt',
                _major: 11,
                _minor: 56,
                retAtt: 1,
                id: item.id,
                shows: 0
              }
              window.post.getPost(obj).then((ret) =>
              {
              })
            }
          })
        })
      }).catch(() =>
      {
        this.$message({message: '已取消删除', type: 'info', customClass: 'mzindex'})
      })
    },
    //视频上传的URL
    getVidUrl()
    {
      let that = this
      window.public.onUploadVideo(that)
    },
    //视频上传之前的钩子
    beforeUploadVideo(file)
    {
      let that = this
      window.public.beforeUploadVideo(file, that)
    },
    //视频上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onVideoSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除视频
    handleRemoveVideo(fileList)
    {
      let that = this
      window.public.handleRemoveVideo(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //————列表页的公共方法——
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/backer/project/xsyzgl/Ysztgl.vue